import { withJsonFormsControlProps } from "@jsonforms/react";
import { useEffect, useRef } from "react";
import RadioInputField from "../radioInputField/RadioInputField";

const StreakRewardModeRadioComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
  } = props;

  const previousRewardModeRef = useRef(data);
  const isNumber = schema.type === "number";

  // Watch for changes in reward_mode and clear conflicting fields
  useEffect(() => {
    const currentRewardMode = data;
    const previousRewardMode = previousRewardModeRef.current;

    if (
      previousRewardMode !== undefined &&
      previousRewardMode !== currentRewardMode &&
      currentRewardMode !== undefined
    ) {
      // Get the root data path to access sibling fields
      const pathParts = path.split(".");
      const parentPath = pathParts.slice(0, -1).join(".");

      // Clear conflicting fields based on the new reward mode
      if (currentRewardMode === "PROGRAM_POINTS") {
        // Switching to PROGRAM_POINTS: clear reward-related and joy points fields
        handleChange(`${parentPath ? parentPath + "." : ""}reward_ids`, undefined);
        handleChange(`${parentPath ? parentPath + "." : ""}catalog_refs`, undefined);
        handleChange(
          `${parentPath ? parentPath + "." : ""}joy_points_value`,
          undefined
        );
      } else if (currentRewardMode === "REWARDS") {
        // Switching to REWARDS: clear points-related fields
        handleChange(
          `${parentPath ? parentPath + "." : ""}program_points_value`,
          undefined
        );
        handleChange(
          `${parentPath ? parentPath + "." : ""}joy_points_value`,
          undefined
        );
      } else if (currentRewardMode === "JOY_POINTS") {
        // Switching to JOY_POINTS: clear program points and reward-related fields
        handleChange(
          `${parentPath ? parentPath + "." : ""}program_points_value`,
          undefined
        );
        handleChange(`${parentPath ? parentPath + "." : ""}reward_ids`, undefined);
        handleChange(`${parentPath ? parentPath + "." : ""}catalog_refs`, undefined);
      }
    }

    // Update the ref for next comparison
    previousRewardModeRef.current = currentRewardMode;
  }, [data, handleChange, path]);

  return (
    <RadioInputField
      path={path}
      value={data}
      label={label}
      disabled={uischema.disabled || !enabled}
      updateValue={(newVal) => {
        const val = isNumber ? Number(newVal) : newVal;
        handleChange(path, val);
      }}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  );
};

export const StreakRewardModeRadioControl = withJsonFormsControlProps(
  StreakRewardModeRadioComponent
);
